import { render, staticRenderFns } from "./PersonSearchModal.vue?vue&type=template&id=9ccf0070&scoped=true"
import script from "./PersonSearchModal.vue?vue&type=script&lang=js"
export * from "./PersonSearchModal.vue?vue&type=script&lang=js"
import style0 from "./PersonSearchModal.vue?vue&type=style&index=0&id=9ccf0070&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccf0070",
  null
  
)

export default component.exports